var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "page-wrapper sys-entry",
      attrs: { "element-loading-text": "正在进入..." }
    },
    [
      _c("div", { staticClass: "entrance-header" }, [
        _c("div", { staticClass: "header-logo" }, [
          _c("div", { staticClass: "swb-row" }, [
            _c("img", {
              directives: [
                {
                  name: "resc-url",
                  rawName: "v-resc-url",
                  value: "/app/image/logo/plat-logo.png",
                  expression: "'/app/image/logo/plat-logo.png'"
                }
              ]
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sys-entry-container" }, [
        _c("div", { staticClass: "swb-row pt45" }, [
          _c("div", { staticClass: "content-box" }, [
            _c("div", { staticClass: "main-head" }, [
              _c("h2", [_vm._v("零售商系统")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "fr mr15",
                  on: {
                    click: function($event) {
                      _vm.doLogout()
                    }
                  }
                },
                [_vm._v("【退出】")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "main-body mt20" }, [
              _vm.entityList.length <= 0 && _vm.showNoDate
                ? _c("div", { staticClass: "notice-search" }, [
                    _c("div", { staticClass: "ns-wrap" }, [
                      _c("i", {
                        staticClass: "ns-icon icon iconfont icon-tttt"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "ns-content" }, [
                        _vm._v("您还没有零售商身份，您可以  "),
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.checkRetailer()
                              }
                            }
                          },
                          [_vm._v("申请零售商")]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.entityList.length > 0
                ? _c("div", { staticClass: "sys-ident" }, [
                    _c(
                      "div",
                      {
                        staticClass: "tabs-nav merchant-choice",
                        staticStyle: { "text-align": "right" }
                      },
                      [
                        _vm.entityList.length > 0
                          ? [
                              _c("span", { staticClass: "entity-label" }, [
                                _vm._v("请选择商户信息:")
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  staticClass: "entity-select",
                                  attrs: {
                                    "collapse-tags": "",
                                    placeholder: "请选择",
                                    filterable: "",
                                    "popper-class": "entity-select-dropdown"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.clickEntity()
                                    }
                                  },
                                  model: {
                                    value: _vm.selectId,
                                    callback: function($$v) {
                                      _vm.selectId = $$v
                                    },
                                    expression: "selectId"
                                  }
                                },
                                _vm._l(_vm.entityList, function(retailer) {
                                  return _c("el-option", {
                                    key: retailer.id,
                                    attrs: {
                                      label: retailer.name,
                                      value: retailer.id
                                    }
                                  })
                                })
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "hint block",
                        staticStyle: { height: "60px", "line-height": "35px" }
                      },
                      [
                        _vm.bizUnionList != null && _vm.bizUnionList.length > 0
                          ? _c(
                              "div",
                              { staticClass: "fl" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: { disabled: _vm.hiddenFlag },
                                    model: {
                                      value: _vm.forBizUnion,
                                      callback: function($$v) {
                                        _vm.forBizUnion = $$v
                                      },
                                      expression: "forBizUnion"
                                    }
                                  },
                                  [_vm._v("是否进入联盟")]
                                ),
                                _vm._v(" "),
                                _vm.forBizUnion
                                  ? _c(
                                      "el-select",
                                      {
                                        staticClass: "ml20",
                                        attrs: { placeholder: "请选择" },
                                        model: {
                                          value: _vm.bizUnionId,
                                          callback: function($$v) {
                                            _vm.bizUnionId = $$v
                                          },
                                          expression: "bizUnionId"
                                        }
                                      },
                                      _vm._l(_vm.bizUnionList, function(item) {
                                        return _c("el-option", {
                                          key: item.id,
                                          attrs: {
                                            label: item.name,
                                            value: item.id
                                          }
                                        })
                                      })
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "fr" },
                          [
                            _c(
                              "el-input",
                              {
                                attrs: { placeholder: "请输入机构名称" },
                                model: {
                                  value: _vm.searchName,
                                  callback: function($$v) {
                                    _vm.searchName = $$v
                                  },
                                  expression: "searchName"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-input__icon el-icon-search",
                                  attrs: { slot: "suffix" },
                                  on: { click: _vm.handleIconClick },
                                  slot: "suffix"
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.entityInfo != null && _vm.entityInfo.retailer.id != null
                      ? _c(
                          "ul",
                          { staticClass: "sys-list row-item company-list" },
                          [
                            _c(
                              "li",
                              {
                                staticClass: "sys-item",
                                staticStyle: { "background-color": "#d1dbe5" }
                              },
                              [
                                _c("a", { staticClass: "clearfix sys-left" }, [
                                  _c(
                                    "div",
                                    { staticClass: "company-logo fl" },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            _vm.entityInfo.retailer
                                              .logoFileBrowseUrl
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "company-info fl ml20" },
                                    [
                                      _c("p", { staticClass: "company-name" }, [
                                        _vm._v(
                                          _vm._s(_vm.entityInfo.retailer.name)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "company-addr" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.entityInfo.retailer.createTime
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.entityInfo.retailer.auditState == -1 &&
                                  _vm.userId != null &&
                                  _vm.entityInfo.retailer.adminId == _vm.userId
                                    ? _c(
                                        "div",
                                        { staticClass: "sys-right enter" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "swb-btn",
                                              on: {
                                                click: function($event) {
                                                  _vm.checkRetailer()
                                                }
                                              }
                                            },
                                            [_vm._v("申请零售商")]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "sys-right",
                                    staticStyle: {
                                      border: "none",
                                      "padding-top": "30px",
                                      "padding-right": "5px"
                                    }
                                  },
                                  [
                                    _vm.scopeList.length > 1
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "请选择" },
                                            model: {
                                              value: _vm.scopeId,
                                              callback: function($$v) {
                                                _vm.scopeId = $$v
                                              },
                                              expression: "scopeId"
                                            }
                                          },
                                          _vm._l(_vm.scopeList, function(item) {
                                            return _c("el-option", {
                                              key: item.id,
                                              attrs: {
                                                label: item.text,
                                                value: item.id
                                              }
                                            })
                                          })
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.entityInfo.retailer.auditState == 1 &&
                                    _vm.entityInfo.retailer.adminId ==
                                      _vm.userId
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "ellipsis-1 swb-btn swb-btn-mini",
                                            staticStyle: {
                                              width: "132px",
                                              "margin-top": "10px"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.getEntryTarget(
                                                  _vm.entityInfo.retailer.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("admin")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.entityInfo.retailer.disabled ||
                            _vm.entityInfo.retailer.outOfBiz
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "sys-item",
                                    staticStyle: {
                                      "background-color": "#d1dbe5"
                                    }
                                  },
                                  [
                                    _c(
                                      "a",
                                      { staticClass: "clearfix sys-left" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "company-logo fl" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  _vm.entityInfo.retailer
                                                    .logoFileBrowseUrl
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "company-info fl ml20"
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "company-name" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.entityInfo.retailer.name
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "company-addr" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon iconfont icon-site-copy mr10"
                                                }),
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.entityInfo.retailer
                                                      .regionName || ""
                                                  ) +
                                                    _vm._s(
                                                      _vm.entityInfo.retailer
                                                        .street || ""
                                                    ) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "sys-right" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "enter mt30",
                                          staticStyle: {
                                            "line-height": "22px",
                                            padding: "0 10px"
                                          }
                                        },
                                        [
                                          _vm.entityInfo.retailer.disabled
                                            ? _c(
                                                "div",
                                                { staticClass: "font-red" },
                                                [_vm._v("该商户已禁用")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.entityInfo.retailer.disabled &&
                                          _vm.entityInfo.retailer.outOfBiz
                                            ? _c(
                                                "div",
                                                { staticClass: "font-red" },
                                                [_vm._v("该商户已歇业")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.entityInfo.retailerComs, function(com) {
                              return !_vm.entityInfo.retailer.disabled &&
                                !_vm.entityInfo.retailer.outOfBiz &&
                                _vm.entityInfo.retailerComs.length > 0
                                ? _c("li", { staticClass: "sys-item" }, [
                                    _c(
                                      "a",
                                      { staticClass: "clearfix sys-left" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "company-logo fl" },
                                          [
                                            _c("img", {
                                              attrs: { src: com.fileBrowseUrl }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "company-info fl ml20"
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "company-name" },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(com.name)
                                                ),
                                                com.closed
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "font-red",
                                                        staticStyle: {
                                                          "font-size": "14px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "（" +
                                                            _vm._s(
                                                              com.closeReason
                                                            ) +
                                                            "）"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "company-addr" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon iconfont icon-site-copy mr10"
                                                }),
                                                _vm._v(
                                                  _vm._s(com.regionName) +
                                                    _vm._s(com.street)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.entityInfo.retailer.auditState == 1 &&
                                    !com.staffDisabled &&
                                    !com.closed &&
                                    com.opened
                                      ? _c(
                                          "div",
                                          { staticClass: "sys-right" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "second-caption" },
                                              [_vm._v("岗位进入")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(com.comRoles, function(
                                              comRole
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass: "mt5",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.getEntryTarget(
                                                        _vm.entityInfo.retailer
                                                          .id,
                                                        comRole.comId,
                                                        comRole.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "ellipsis-1 swb-btn swb-btn-mini",
                                                      staticStyle: {
                                                        width: "132px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(comRole.name)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.entityInfo.retailer.auditState == 1 &&
                                    com.closed
                                      ? _c(
                                          "div",
                                          { staticClass: "sys-right" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "second-caption" },
                                              [_vm._v("岗位进入")]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(0, true)
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.entityInfo.retailer.auditState == 1 &&
                                    !com.opened
                                      ? _c(
                                          "div",
                                          { staticClass: "sys-right" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "second-caption" },
                                              [_vm._v("岗位进入")]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(1, true)
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.entityInfo.retailer.auditState == 1 &&
                                    com.staffDisabled &&
                                    !com.closed
                                      ? _c(
                                          "div",
                                          { staticClass: "sys-right" },
                                          [_vm._m(2, true)]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.entityInfo.retailer.auditState == 0
                                      ? _c(
                                          "div",
                                          { staticClass: "sys-right" },
                                          [_vm._m(3, true)]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.entityInfo.retailer.auditState == -1
                      ? _c("div", { staticClass: "hint block mt20 mb20" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c("p", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.entityInfo.retailer.auditDesc))
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sys-ident block pagination-layout" },
                      [
                        _c("el-pagination", {
                          staticClass: "mt10",
                          attrs: {
                            background: "",
                            "page-size": _vm.pageSize,
                            "page-sizes": _vm.pageSizes,
                            "current-page": _vm.pageNumber,
                            total: _vm.totalCount,
                            "pager-count": 5,
                            layout: "total, sizes, prev, pager, next, jumper"
                          },
                          on: {
                            "current-change": _vm.handlePageChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt20" }, [
      _c("div", { staticClass: "font-red" }, [_vm._v("已闭店")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt20" }, [
      _c("div", { staticClass: "font-red" }, [_vm._v("未开店")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "enter mt30",
        staticStyle: { "line-height": "22px", padding: "0 10px" }
      },
      [_c("div", { staticClass: "font-red" }, [_vm._v("该员工已禁用")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "enter mt30",
        staticStyle: { "line-height": "22px", padding: "0 10px" }
      },
      [
        _c("div", { staticClass: "font-red" }, [_vm._v("已提交申请")]),
        _vm._v(" "),
        _c("div", { staticClass: "font-red" }, [_vm._v("等待认证")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", { staticClass: "icon iconfont icon-jinggao1 font-red" }),
      _vm._v(" "),
      _c("span", { staticClass: "font-red" }, [_vm._v("审核不通过原因：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4339d0f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4339d0f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/user/ScopeEntityList.vue
// module id = 4617
// module chunks = 0